/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Replytomailaddress3Inputs */

const en__field_replytomailaddress3 = /** @type {(inputs: _Field_Replytomailaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email reply address`)
};

const de__field_replytomailaddress3 = /** @type {(inputs: _Field_Replytomailaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail Antwort-Adresse`)
};

/**
* | output |
* | --- |
* | "email reply address" |
*
* @param {_Field_Replytomailaddress3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_replytomailaddress3 = /** @type {((inputs?: _Field_Replytomailaddress3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Replytomailaddress3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_replytomailaddress3(inputs)
	return de__field_replytomailaddress3(inputs)
});
export { _field_replytomailaddress3 as "_field_replyToMailAddress" }